<template>
    <section class="container-fluid stepsBar">
        <div class="container mt-md-5 pb-5" sty>
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <div>
                        <h1 class="mb-4 wow fadeInUp">About Us</h1>
                        <p class="font18">WeVisu’s founders have over two decades of experience in project design and business operations—they’re passionate about developing universal solutions that benefit individuals, families, and businesses.</p>
                    </div>
                    <p class="mb-2"><strong>We’re experienced in residential & commercial:</strong></p>
                    <ul class="mb-3 ml-4 lis">
                        <li>Construction</li>
                        <li>Interior design</li>
                        <li>Architecture</li>
                        <li>Contractors (general, design-build, construction)</li>
                        <li>Sales</li>
                        <li>Information Technology (IT)</li>
                        <li>Consulting</li>
                        <li>Business & administration</li>
                    </ul>
                    <p>With years of on-field experience, a passion for customer satisfaction, and a lot of planning, we developed a design solution that’s accessible to all—from vendors to customers. WeVisu helps businesses improve workflows, brand value, and customer connection through an innovative, personal approach.</p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'aboutus',
    components: {

    },
    created() {



    },

    mounted() {

    },
}

</script>
